// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__PqYrp","layoutIsOpen":"layout_layoutIsOpen__h1PpW"};